import { DatePickerProps, Select } from 'antd';
import React from 'react';
import { Location, SearchLocation } from '../api/models/locations';
import dayjs from 'dayjs';

export const getLocationSelectOptions = (
  locations: Location[] | SearchLocation[],
  getTitleFunc: (location: any) => string,
  optionStyle?: string,
  dataTestId?: string
) => {
  return locations.map((location, index) => (
    <Select.Option
      value={location.id}
      key={`dropoff_${location.id}`}
      className={optionStyle}
      data-testid={`${dataTestId || 'dropOffLocationItem'}_${index}`}
    >
      {getTitleFunc(location)}
    </Select.Option>
  ));
};

export const isNumber = (n?: number): boolean => {
  return Number(n) === n;
};

export const formatDateTime = (dateTime: number | Date | undefined) => dayjs(dateTime).format('DD/MM/YYYY hh:mm a');

export const isAutoGeneratedEmail = (email: string): boolean => {
  const regex = /^UPDATE_EMAIL_\d+_\d+@careem-r\.com$/;
  return regex.test(email);
};

export const onlyOneDayAllowed: DatePickerProps['disabledDate'] = current => {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 2);
  const today = new Date();
  today.setDate(today.getDate());

  return Boolean(current && (current.startOf('day').toDate() < yesterday || current.startOf('day').toDate() > today));
};

export const getCarePhoneNumber = (city: string): string => {
  switch (city) {
    case 'Riyadh':
    case 'Jeddah':
    case 'Dammam / Khobar':
    case 'Aseer':
      return '+966114377033';
    case 'Irbid':
    case 'Amman':
      return '+96265600381';
    case 'Dubai':
    case 'Abu Dhabi':
      return '+97142790334';
    default:
      return '+97142790334'; // Default to Dubai's number
  }
};
